/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Success_Createcategory1Inputs */

const en_cases_settings_success_createcategory1 = /** @type {(inputs: Cases_Settings_Success_Createcategory1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category created`)
};

/**
* | output |
* | --- |
* | "Category created" |
*
* @param {Cases_Settings_Success_Createcategory1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cases_settings_success_createcategory1 = /** @type {((inputs?: Cases_Settings_Success_Createcategory1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Success_Createcategory1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_success_createcategory1(inputs)
});
export { cases_settings_success_createcategory1 as "cases_settings_success_createCategory" }